export default "__VITE_ASSET__DGgH4vko__"